import * as contentful  from 'contentful'

const client = contentful.createClient({
    
    space: process.env.REACT_APP_SPACE_ID,
    accessToken: process.env.REACT_APP_ACCESS_TOKEN
    

})
export default client

// const useContentful = () =>{

//     const client = createClient({
        
//         space:process.env.REACT_APP_SPACE_ID,
//         accessToken:process.env.REACT_APP_ACCESS_TOKEN,
//         host:"cdn.contentful.com"

//     })
//     return client}
